import { useAppDispatch } from "integrations/redux/hooks"
import { setGlobalNotificationContext } from "user/profile/slice"
import { GlobalNotificationStatus } from "@nova/component-global-notification"
import { CreatableReportTemplate } from "@nova/schemas"
import {
    useCreateReportTemplate,
    useGenerateReport,
    useReportTemplates,
} from "features/pilot-tracking/report-templates/ReportTemplateQueries"
import { ReportTemplateForm } from "features/pilot-tracking/report-templates/ReportTemplateForm"
import { useRouter } from "pages"
import { getGenericWorkspacePage, getGenericWorkspacePageHeader } from "../WorkspaceRoutes"

export const CreateReportTemplatePage = getGenericWorkspacePage({
    Header: getGenericWorkspacePageHeader({
        title: "Create Report Template",
    }),
    Content: CreateReportTemplatePageContent,
    maxWidth: 1200,
})

function CreateReportTemplatePageContent() {
    const dispatch = useAppDispatch()
    const router = useRouter("/workspace/:workspaceId")
    const { createReportTemplate } = useCreateReportTemplate()
    const { generateReport } = useGenerateReport()
    const { data: reportTemplates } = useReportTemplates()

    if (!reportTemplates) return null

    const handleSubmit = async (payload: CreatableReportTemplate, downloadOnComplete: boolean) => {
        const template = await createReportTemplate(payload)

        if (!template) {
            dispatch(
                setGlobalNotificationContext({
                    message: `Failed to create ${payload.name}. Please try again.`,
                    status: GlobalNotificationStatus.error,
                    timeoutInMs: 3000,
                })
            )
            return
        }

        dispatch(
            setGlobalNotificationContext({
                message: `${template.name} has been created.`,
                status: GlobalNotificationStatus.success,
                timeoutInMs: 3000,
            })
        )

        if (downloadOnComplete) {
            generateReport({ id: template.id, name: template.name })
        }
    }

    return (
        <div className="w-full flex justify-center h-full overflow-hidden pb-4">
            <ReportTemplateForm
                initialValues={{ name: `Report #${reportTemplates.length + 1}` }}
                onCancel={() => router.navigate({ path: "/fleet/reports" })}
                onSubmit={handleSubmit}
                operation="create"
                afterSubmit={() => router.navigate({ path: "/fleet/reports" })}
            />
        </div>
    )
}
